// 업테코드

export const businessTypeCode = {
  숙박업: [
    { label: "특급호텔", code: "1001" },
    { label: "1급 호텔", code: "1002" },
    { label: "2급 호텔", code: "1003" },
    { label: "콘도", code: "1010" },
    { label: "기타숙박업", code: "1020" },
  ],
  여행: [
    { label: "항공사", code: "1101" },
    { label: "관광여행", code: "1110" },
    { label: "고속버스", code: "1120" },
    { label: "철도", code: "1121" },
    { label: "여객선", code: "1122" },
    { label: "택시", code: "1123" },
    { label: "택시회사", code: "1124" },
    { label: "렌터카", code: "1130" },
    { label: "기타교통수단", code: "1199" },
  ],
  레저용품: [
    { label: "골프용품 전문점", code: "2001" },
    { label: "스포츠·레져용품", code: "2002" },
    { label: "총포류판매점", code: "2003" },
    { label: "악기점", code: "2010" },
    { label: "피아노대리점", code: "2011" },
    { label: "음반,영상물", code: "2020" },
  ],
  레저업소: [
    { label: "골프경기장", code: "2101" },
    { label: "골프연습장", code: "2102" },
    { label: "카 지 노", code: "2103" },
    { label: "스크린골프", code: "2104" },
    { label: "스 키 장", code: "2110" },
    { label: "볼 링 장", code: "2111" },
    { label: "테니스장", code: "2112" },
    { label: "수 영 장", code: "2113" },
    { label: "헬스클럽", code: "2114" },
    { label: "종합레져타운", code: "2120" },
    { label: "당 구 장", code: "2121" },
    { label: "노 래 방", code: "2130" },
    { label: "기타레져업소", code: "2199" },
  ],
  "문화·취미": [
    { label: "골동품점", code: "2201" },
    { label: "화랑", code: "2202" },
    { label: "화방·표구점", code: "2210" },
    { label: "민예·공예품", code: "2215" },
    { label: "수족관", code: "2220" },
    { label: "화원", code: "2230" },
    { label: "애완동물", code: "2240" },
    { label: "영화관", code: "2250" },
    { label: "티켓", code: "2251" },
    { label: "문화취미기타", code: "2299" },
  ],
  가구: [
    { label: "일반가구", code: "3001" },
    { label: "철제가구", code: "3002" },
    { label: "기타가구", code: "3099" },
  ],
  전기제품: [
    { label: "가전제품", code: "3101" },
    { label: "냉열기기", code: "3102" },
    { label: "기타전기제품", code: "3199" },
  ],
  주방용구: [
    { label: "주방용구", code: "3201" },
    { label: "주방용식기", code: "3202" },
    { label: "정수기", code: "3210" },
    { label: "기타주방용구", code: "3299" },
  ],
  연료판매점: [
    { label: "주유소", code: "3301" },
    { label: "LPG 취급점", code: "3302" },
    { label: "유류판매", code: "3304" },
    { label: "SK주유소", code: "3305" },
    { label: "SK가스충전소", code: "3306" },
    { label: "GS주유소", code: "3307" },
    { label: "현대정유(오일뱅크)", code: "3308" },
    { label: "쌍용S-OIL", code: "3309" },
    { label: "GS 가스충전소", code: "3311" },
    { label: "현대정유 가스충전소", code: "3312" },
    { label: "쌍용S-OIL 가스충전소", code: "3313" },
    { label: "E1가스충전소", code: "3315" },
    { label: "전기차충전소", code: "3321" },
    { label: "기타연료", code: "3399" },
  ],
  광학제품: [
    { label: "카메라", code: "3401" },
    { label: "DP&E", code: "3402" },
    { label: "기타광학제품", code: "3499" },
  ],
  유통업영리: [
    { label: "일반백화점", code: "4001" },
    { label: "자사카드발행백화점", code: "4002" },
    { label: "대형할인점", code: "4004" },
    { label: "편 의 점", code: "4010" },
    { label: "슈퍼마켓", code: "4020" },
    { label: "연 쇄 점", code: "4021" },
    { label: "보훈,복지매장", code: "4031" },
    { label: "면 세 점", code: "4040" },
    { label: "농축수산 가공품", code: "4050" },
    { label: "통신판매업1", code: "4060" },
    { label: "CATV홈쇼핑", code: "4061" },
    { label: "통신판매업2", code: "4062" },
    { label: "인터넷P/G", code: "4076" },
    { label: "인터넷 종합 Mall", code: "4077" },
    { label: "인터넷 Mall", code: "4078" },
    { label: "상 품 권", code: "4080" },
    { label: "상품권전문판매", code: "4081" },
    { label: "전자상거래상품권", code: "4083" },
    { label: "전자상거래상품권전문판매", code: "4084" },
    { label: "PG상품권", code: "4085" },
    { label: "기타유통업", code: "4099" },
  ],
  유통업비영리: [
    { label: "공무원 연금 매점", code: "4101" },
    { label: "농,축협 직영매장", code: "4110" },
    { label: "농협하나로클럽", code: "4111" },
    { label: "구내매점(국가기관 등)", code: "4121" },
    { label: "기타비영리유통", code: "4199" },
  ],
  의류: [
    { label: "정장", code: "4201" },
    { label: "아동의류", code: "4203" },
    { label: "양 품 점", code: "4204" },
    { label: "내의판매", code: "4205" },
    { label: "와이셔츠·타이", code: "4206" },
    { label: "캐주얼 의류", code: "4207" },
    { label: "스포츠 의류", code: "4208" },
    { label: "단체복", code: "4209" },
    { label: "맞춤복점", code: "4210" },
    { label: "기타의류", code: "4299" },
  ],
  직물: [
    { label: "옷감·직물", code: "4301" },
    { label: "카페트,커튼,천막,지물", code: "4302" },
    { label: "침구·수예점", code: "4303" },
    { label: "혼수전문점", code: "4304" },
    { label: "기타직물", code: "4399" },
  ],
  신변잡화: [
    { label: "가   방", code: "4401" },
    { label: "시   계", code: "4410" },
    { label: "귀금속", code: "4411" },
    { label: "액세서리", code: "4412" },
    { label: "제   화", code: "4420" },
    { label: "신   발", code: "4421" },
    { label: "기념품점", code: "4430" },
    { label: "성인용품점", code: "4481" },
    { label: "기타잡화", code: "4499" },
  ],
  서적문구: [
    { label: "일반서적", code: "5001" },
    { label: "전문서적", code: "5002" },
    { label: "정기간행물", code: "5003" },
    { label: "출판 및 인쇄물", code: "5010" },
    { label: "교육용테이프판매", code: "5020" },
    { label: "문구용품", code: "5030" },
    { label: "과학기자재", code: "5040" },
    { label: "완구점", code: "5050" },
    { label: "기타서적문구", code: "5099" },
  ],
  학원: [
    { label: "외국어학원", code: "5101" },
    { label: "기능학원", code: "5102" },
    { label: "컴퓨터학원", code: "5103" },
    { label: "예·체능계학원", code: "5104" },
    { label: "보습학원", code: "5105" },
    { label: "학습지 교육", code: "5106" },
    { label: "대학등록금", code: "5120" },
    { label: "초중고교육기관", code: "5121" },
    { label: "유치원", code: "5122" },
    { label: "유아원", code: "5123" },
    { label: "독서실", code: "5191" },
    { label: "유학원", code: "5192" },
    { label: "기타 교육기관", code: "5199" },
  ],
  사무통신: [
    { label: "컴퓨터", code: "5201" },
    { label: "사무용 OA기기", code: "5202" },
    { label: "통신기기", code: "5210" },
    { label: "통신기기(무이자할부)", code: "5211" },
    { label: "전자(상우회)", code: "5280" },
    { label: "기타 사무용품", code: "5299" },
  ],
  자동차판매: [
    { label: "국산신차판매", code: "6001" },
    { label: "중고자동차판매", code: "6002" },
    { label: "수입자동차", code: "6003" },
    { label: "이륜차판매", code: "6004" },
    { label: "중고자동차위탁판매", code: "6005" },
    { label: "기타운송", code: "6099" },
  ],
  "자동차정비·유지": [
    { label: "자동차시트·타이어", code: "6101" },
    { label: "자동차부품", code: "6102" },
    { label: "윤활유 전문 판매", code: "6103" },
    { label: "자동차정비", code: "6110" },
    { label: "국산신차 직영부품·정비업소", code: "6111" },
    { label: "중장비수리", code: "6112" },
    { label: "카인테리어", code: "6120" },
    { label: "세차장", code: "6130" },
    { label: "주차장", code: "6140" },
    { label: "견인서비스", code: "6150" },
    { label: "가타자동차서비스", code: "6199" },
  ],
  보험: [
    { label: "생명보험", code: "6201" },
    { label: "손해보험", code: "6210" },
    { label: "기타보험", code: "6299" },
  ],
  병원: [
    { label: "종합병원", code: "7001" },
    { label: "병      원", code: "7010" },
    { label: "한방병원", code: "7014" },
    { label: "치과병원", code: "7015" },
  ],
  의원: [
    { label: "의      원", code: "7020" },
    { label: "한  의 원", code: "7021" },
    { label: "치과의원", code: "7022" },
  ],
  약국: [
    { label: "제약회사", code: "7040" },
    { label: "약   국", code: "7041" },
    { label: "한약방", code: "7042" },
  ],
  기타의료기관: [
    { label: "조산원", code: "7043" },
    { label: "산후조리원", code: "7044" },
    { label: "동물병원", code: "7050" },
    { label: "건강진단", code: "7060" },
    { label: "기타의료기관 및 기타의료기기", code: "7099" },
  ],
  보건위생: [
    { label: "이용원", code: "7101" },
    { label: "미용원", code: "7102" },
    { label: "피부미용실", code: "7103" },
    { label: "안    경", code: "7105" },
    { label: "화장품", code: "7110" },
    { label: "미용재료", code: "7111" },
    { label: "의료용품", code: "7112" },
    { label: "사우나", code: "7120" },
    { label: "안마/스포츠마사지", code: "7121" },
    { label: "기타대인서비스", code: "7199" },
  ],
  "일반·휴게음식": [
    { label: "일반한식", code: "8001" },
    { label: "갈비전문점", code: "8002" },
    { label: "한정식", code: "8003" },
    { label: "일식·회집", code: "8004" },
    { label: "중국식", code: "8005" },
    { label: "서양음식", code: "8006" },
    { label: "칵테일바", code: "8010" },
    { label: "주점", code: "8013" },
    { label: "스넥", code: "8021" },
    { label: "위탁급식업", code: "8031" },
  ],
  유흥단란: [
    { label: "유흥주점", code: "8101" },
    { label: "단란주점", code: "8201" },
  ],
  음료식품: [
    { label: "제과점", code: "8301" },
    { label: "정육점", code: "8302" },
    { label: "주류 판매점", code: "8303" },
    { label: "농·축·수산품", code: "8310" },
    { label: "미곡상", code: "8320" },
    { label: "기타음료식품", code: "8399" },
  ],
  건강식품: [
    { label: "홍삼제품", code: "8401" },
    { label: "인삼제품", code: "8402" },
    { label: "기타건강식품", code: "8499" },
  ],
  "건축 자재": [
    { label: "보일러·펌프·샷시", code: "9001" },
    { label: "건축용 요업제품", code: "9002" },
    { label: "조명기구", code: "9003" },
    { label: "페인트", code: "9004" },
    { label: "유리", code: "9005" },
    { label: "목재·석재·철물", code: "9006" },
    { label: "인테리어전문", code: "9010" },
    { label: "부동산 분양", code: "9020" },
    { label: "기타건축자재", code: "9099" },
  ],
  용역서비스: [
    { label: "종합용역", code: "9101" },
    { label: "장례서비스업", code: "9110" },
    { label: "혼례서비스", code: "9111" },
    { label: "보관및 창고업", code: "9120" },
    { label: "화물운송", code: "9121" },
    { label: "사무서비스", code: "9130" },
    { label: "정보서비스", code: "9131" },
    { label: "법률회계서비스(개인)", code: "9132" },
    { label: "부동산 중개·임대", code: "9133" },
    { label: "소프트웨어", code: "9134" },
    { label: "법률회계서비스(법인)", code: "9135" },
    { label: "공공요금대행서비스/소득공제비대상", code: "9140" },
    { label: "공공요금대행서비스/소득공제대상", code: "9141" },
    { label: "통신서비스/소득공제비대상", code: "9149" },
    { label: "통신서비스/소득공제대상", code: "9150" },
    { label: "CATV", code: "9151" },
    { label: "이동통신요금", code: "9153" },
    { label: "위성방송", code: "9154" },
    { label: "조세서비스", code: "9160" },
    { label: "자체물품대금", code: "9180" },
    { label: "기타용역서비스", code: "9199" },
  ],
  수리서비스: [
    { label: "레져용품수리", code: "9201" },
    { label: "가정용품수리", code: "9202" },
    { label: "신변잡화수리", code: "9203" },
    { label: "사무·통신기기수리", code: "9204" },
    { label: "세탁소", code: "9210" },
    { label: "기타수리서비스", code: "9299" },
  ],
  "회원제 형태업소": [
    { label: "레져업소", code: "9301" },
    { label: "자동차서비스", code: "9302" },
    { label: "사무서비스", code: "9303" },
    { label: "서적", code: "9304" },
    { label: "학원", code: "9305" },
    { label: "건강식품", code: "9306" },
    { label: "기타1", code: "9395" },
    { label: "기타2", code: "9396" },
    { label: "기타3", code: "9397" },
    { label: "기타4", code: "9398" },
    { label: "기타5", code: "9399" },
  ],
  생활서비스: [
    { label: "생활서비스(통신판매)", code: "9501" },
    { label: "일반(통신판매)", code: "9510" },
  ],
  농업: [
    { label: "농기계", code: "9601" },
    { label: "비료,사료,종자", code: "9602" },
    { label: "기타농업관련", code: "9699" },
  ],
  무인판매: [
    { label: "일반자판기", code: "9801" },
    { label: "담배자판기", code: "9802" },
    { label: "공공자판기", code: "9803" },
  ],
  기타: [
    { label: "기계공구", code: "9901" },
    { label: "비영리/대상", code: "9910" },
    { label: "비영리/비대상", code: "9911" },
    { label: "P2P송금", code: "9921" },
    { label: "사업자미등록개인", code: "9931" },
    { label: "외국인전용가맹점", code: "9993" },
    { label: "비씨카드 정산용가맹점", code: "9995" },
    { label: "비씨카드 정산용(할인)", code: "9996" },
    { label: "기타 전문점", code: "9998" },
  ],
};
